enum LocalStorageKey {
    MODE = '_mode',
    THEME = '_theme',
    USER_ID = '_userId',
    USERNAME = '_username',
    EMAIL = '_email',
    ACCESS = '_access',
    LAST_ACTIVITY = '_lastActivity',
    TOKEN = '_token',
    REFRESH_TOKEN = '_refreshToken',
    EXPIRATION = '_expiration',
    TOKEN_TYPE = '_tokenType',
    TENANT_DISPLAY_NAME = '_tenantDisplayName',
    API_BASE_URL = '_apiBaseUrl',
    ORDER_SORTING = '_orderSorting',
    ORDER_VESSEL_FILTERING = '_orderVesselFiltering',
    SIGNATURE = '_signature',
}

export default LocalStorageKey;